import { useEffect, useState } from 'react';
// import EcoImg from 'eco-design/base/eco-img';
import { useProductStore } from '../../../../ProductProvider';
import { IconA, IconB, IconC, IconD, IconE, IconF, IconG, IconH, IconI, IconJ, IconK } from './Svg';
import styled from './index.module.scss';
import Section from './Section';
import Panoramic from './Panoramic';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { IPageStatus } from '@elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoImg from 'eco-design/base/eco-img';

export default function PathToZero() {
    const { t } = useLang('theProduct.pathtozero');
    const { isMobile } = useGlobal();
    const { pageStatus } = useProductStore();
    const [numberStart, setNumberStart] = useState(false);

    const list = [
        {
            title: t('pathtozero_a_title'),
            subTitle: t('pathtozero_a_subtitle'),
            number: Number(t('pathtozero_a_number')),
            numberDesc: t('pathtozero_energybills'),
            iconList: [IconA, IconB, IconC, IconD],
            backgroundpad: 'https://websiteoss.ecoflow.com/upload/video/1744450973496/steam1.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745752574794/steam1.jpg',
            background: 'https://websiteoss.ecoflow.com/upload/video/1744451125150/steam1-m.mp4',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1745753014271/steam1-m.jpg',
        },
        {
            title: t('pathtozero_b_title'),
            subTitle: t('pathtozero_b_subtitle'),
            number: Number(t('pathtozero_b_number')),
            numberDesc: t('pathtozero_energybills'),
            iconList: [IconA, IconB, IconC, IconD, IconE, IconF],
            backgroundpad: 'https://websiteoss.ecoflow.com/upload/video/1744451005927/steam2.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745752608525/steam2.jpg',
            background: 'https://websiteoss.ecoflow.com/upload/video/1745926033906/AC%20Pro.mp4',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1745753038125/steam2-m.jpg',
        },
        {
            title: t('pathtozero_c_title'),
            subTitle: t('pathtozero_c_subtitle'),
            number: Number(t('pathtozero_c_number')),
            numberDesc: t('pathtozero_energybills'),
            iconList: [IconA, IconB, IconC, IconD, IconE, IconF, IconG],
            backgroundpad: 'https://websiteoss.ecoflow.com/upload/video/1744451026447/steam3.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745932949833/steam3.jpg',
            background: 'https://websiteoss.ecoflow.com/upload/video/1744451148501/steam3-m.mp4',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1745753049569/steam3-m.jpg',
        },
        {
            title: t('pathtozero_d_title'),
            subTitle: t('pathtozero_d_subtitle'),
            number: Number(t('pathtozero_d_number')),
            numberDesc: t('pathtozero_energybills'),
            numberDesc2: t('pathtozero_d_numberdesc2'),
            iconList: [IconA, IconB, IconC, IconD, IconE, IconF, IconG, IconH, IconI, IconJ, IconK],
            backgroundpad: 'https://websiteoss.ecoflow.com/upload/video/1745752193501/steam4.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745752635223/steam4.jpg',
            background: 'https://websiteoss.ecoflow.com/upload/video/1745752215819/steam4-m.mp4',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1745753060261/steam4-m.jpg',
        },
    ];

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         // const windowWidth = document.documentElement.scrollWidth;
    //         const windowWidth = isMobile ? window.innerWidth : document.documentElement.scrollWidth;
    //         // return;
    //         const windowHeight = window.innerHeight;
    //         let option = {};
    //         if (windowWidth >= 1024) {
    //             option = {
    //                 asyncFromTo: [
    //                     // 图一左移
    //                     [`.animation-box .move-box .top-video .video1`, { opacity: 1 }, { opacity: 0 }, 0.5],
    //                     [`.animation-box .move-box .top-video .video2`, { opacity: 0 }, { opacity: 1 }, 0.5],
    //                     // 只控制外层透明度会出bug
    //                     [`.animation-box .text-box .text-0 .other .content-box`, { opacity: 1 }, { opacity: 0 }, 0.25],
    //                     [`.animation-box .text-box .text-0 .other .content-header`, { opacity: 1 }, { opacity: 0 }, 0.25],
    //                     [`.animation-box .text-box .text-1 .other .content-box`, { opacity: 0 }, { opacity: 1 }, 0.25],
    //                     [`.animation-box .text-box .text-1 .other .content-header`, { opacity: 0 }, { opacity: 1 }, 0.25],
    //                     // 隐藏换图三
    //                     [`.animation-box .move-box .top-video .video2`, { opacity: 1 }, { opacity: 0 }, 0.5],
    //                     [
    //                         `.animation-box .move-box .bottom-video .video3`,
    //                         { scale: 2, opacity: 0, x: windowWidth / 4, y: -windowHeight / 2 },
    //                         { scale: 2, opacity: 1, x: windowWidth / 4, y: -windowHeight / 2 },
    //                         0.5,
    //                     ],
    //                     [`.animation-box .text-box .text-1 .other .content-box`, { opacity: 1 }, { opacity: 0 }, 0.25],
    //                     [`.animation-box .text-box .text-1 .other .content-header`, { opacity: 1 }, { opacity: 0 }, 0.25],
    //                     [`.animation-box .text-box .text-2 .other .content-box`, { opacity: 0 }, { opacity: 1 }, 0.25],
    //                     [`.animation-box .text-box .text-2 .other .content-header`, { opacity: 0 }, { opacity: 1 }, 0.25],
    //                     // 图四覆盖
    //                     [
    //                         `.animation-box .move-box .bottom-video .video4`,
    //                         { scale: 2, opacity: 0, x: windowWidth / 4, y: -windowHeight / 2 },
    //                         { scale: 2, opacity: 1, x: windowWidth / 4, y: -windowHeight / 2 },
    //                         1,
    //                     ],
    //                     [`.animation-box .text-box .text-2 .other .content-box`, { opacity: 1 }, { opacity: 0 }, 0.25],
    //                     [`.animation-box .text-box .text-2 .other .content-header`, { opacity: 1 }, { opacity: 0 }, 0.25],
    //                     [`.animation-box .text-box .text-3 .other .content-box`, { opacity: 0 }, { opacity: 1 }, 0.25],
    //                     [`.animation-box .text-box .text-3 .other .content-header`, { opacity: 0 }, { opacity: 1 }, 0.25],
    //                     // 缩小
    //                     [
    //                         `.animation-box .move-box .bottom-video .video4`,
    //                         { scale: 2, opacity: 1, x: windowWidth / 4, y: -windowHeight / 2 },
    //                         { scale: 1, opacity: 1, x: 0, y: 0 },
    //                         1,
    //                     ],
    //                     [`.animation-box .move-box .bottom-video .video4`, { scale: 1, opacity: 1, x: 0, y: 0 }, { scale: 1, opacity: 1, x: 0, y: 0 }, 1],
    //                 ],
    //                 asyncTimeLine: [0.5, 0.5, 0.5, 0.5, 0.75, 0.75, 1.5, 1.5, 1.5, 1.5, 1.75, 1.75, 2.5, 2.5, 2.5, 2.75, 2.75, 3, 4],
    //                 triggerElement: '.animation-box',
    //                 onProcess: (percent: any) => {
    //                     if (percent * 100 > 75 && !numberStart) {
    //                         setNumberStart(true);
    //                     }
    //                 },
    //                 triggerHook: 1,
    //                 offset: '100%',
    //                 duration: '300%',
    //             };
    //         } else {
    //             option = {
    //                 triggerElement: '.animation-box .text-3',
    //                 onEnter: () => {
    //                     setNumberStart(true);
    //                 },
    //                 triggerHook: 1,
    //                 offset: '70%',
    //                 duration: '30%',
    //             };
    //         }
    //         const sceneA = AniContainer.create(option);
    //         return () => AniContainer.removeScene(sceneA);
    //     }
    // }, []);

    return (
        <>
            <div className={`${styled.PathToZero} GtmModuleData-section`} data-section-id="PathToZero" data-section-title={t('pathtozero_title')}>
                {pageStatus === IPageStatus.statusA && (
                    <div className="pathtozero-header">
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1745899216468/steam0.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1745899216468/steam0.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1744632929994/steam0-m.jpg"
                        />
                        <p className="head-text">{t('pathtozero_title')}</p>
                    </div>
                )}
                {(pageStatus === IPageStatus.statusB || pageStatus === IPageStatus.statusC) && <Panoramic />}
                {/* <div className="animation-box">
                    <div className="text-box">
                        {list.map((item, index) => (
                            <div key={index} className={`pathtozero-item-text text-${index}`}>
                                <Section deatil={item} numberStart={numberStart} />
                            </div>
                        ))}
                    </div>
                    <div className="move-box">
                        <div className="top-video">
                            <EcoImgVideo
                                className="video1"
                                isVideo
                                pc="https://websiteoss.ecoflow.com/upload/video/1744450973496/steam1.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1745752574794/steam1.jpg"
                            />
                            <EcoImgVideo
                                className="video2"
                                isVideo
                                pc="https://websiteoss.ecoflow.com/upload/video/1744451005927/steam2.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1745752608525/steam2.jpg"
                            />
                        </div>
                        <div className="bottom-video">
                            <EcoImgVideo
                                className="video3"
                                isVideo
                                pc="https://websiteoss.ecoflow.com/upload/video/1744451026447/steam3.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1745932949833/steam3.jpg"
                            />
                            <EcoImgVideo
                                className="video4"
                                isVideo
                                pc="https://websiteoss.ecoflow.com/upload/video/1745752193501/steam4.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1745752635223/steam4.jpg"
                            />
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
}
